export default __webpack_public_path__ + "resources/icons/d412-4bd8.png";